import { setStartTime } from './chatFilterSetters';
const updateStartTime = (filters, value) => {
  return setStartTime(value, filters);
};
export default updateStartTime;